import React from 'react';

import currencyFormat from 'components/Widgets/currencyFormat';

export default [
  {
    name: 'Date',
    selector: (row) => row.attributes.issued,
    sortable: true,
  },
  {
    name: 'Invoice Number',
    selector: (row) => row.attributes.invoice_number,
    sortable: true,
  },
  {
    name: 'Cycle',
    selector: (row) => row.attributes.cycle.name,
    sortable: true,
  },
  {
    name: 'Status',
    selector: (row) => row.attributes.status,
    cell: (row) => <span className="text-capitalize">{row.attributes.status}</span>,

    sortable: true,
  },
  {
    name: 'Total',
    selector: (row) => Number(row.attributes.invoice_total_amount),
    cell: (row) => currencyFormat(
      row.attributes.invoice_total_amount,
      { currency: row.attributes.invoice_total_currency },
    ),
    sortable: true,
  },
];
